import { InputNumber } from 'antd';
import React from 'react';

import {
  INTEREST,
  MIN_INTEREST,
} from '@/constants/payment-method/payment.constants';
import { numberWithSpacesToString } from '@/services/string-format.service';

import styles from './price-input.module.scss';

export const PriceInput: React.FC<{
  prefix: string;
  value: number;
  onChange: (value: number, name?: string) => void;
  name?: string;
  step?: number;
  min?: number;
  max?: number;
}> = ({ prefix, value, onChange, name, step, min, max }) => {
  const handleChange = (val: number | null) => {
    if (val === null || val === undefined) {
      onChange(min ?? 0, name);
      return;
    }

    if (min !== undefined && val < min) {
      onChange(min, name);
      return;
    }

    if (max !== undefined && val > max) {
      onChange(max, name);
      return;
    }

    onChange(val, name);
  };

  const formatValue = (value: number | undefined) => {
    if (value === undefined) return '';
    return numberWithSpacesToString(value, ' ') || '';
  };

  const parseValue = (displayValue: string | undefined): number => {
    if (!displayValue) return min ?? 0;
    const parsed = Number(displayValue.replace(/\s/g, ''));

    if (isNaN(parsed)) return min ?? 0;
    return parsed;
  };

  return (
    <div className={styles.inputWrapper}>
      <span className={styles.inputPrefix}>{prefix}</span>
      <InputNumber
        className="priceInput"
        name={name}
        min={min ?? (name === INTEREST ? MIN_INTEREST : 0)}
        max={max}
        onChange={handleChange}
        formatter={formatValue}
        parser={parseValue}
        value={value}
        step={step}
        precision={2}
      />
    </div>
  );
};
